// function to show in us currency format
export const formatCentsToDollarsWithDollarSign = (value: number) => {

  if (value == null){
    return "NA";
  }
  const trimNumber = +(+convertCentsToDollars(+value)).toFixed(2);
  const formattedValue = Intl.NumberFormat("en", {
    currency: "USD",
    style: "currency",
  }).format(trimNumber);
  return formattedValue;
};


export const convertCentsToDollars = (cents: number | string | null | undefined): number => {
  if (cents === null || cents === undefined || cents === '') return 0;
  const numericCents = typeof cents === 'string' ? parseFloat(cents) : cents;
  if (isNaN(numericCents)) return 0;
  return numericCents / 100;
};

export const convertDollarToCents = (dollars: string | number | null | undefined): number => {
  if (dollars === null || dollars === undefined || dollars === '') return 0;
  const numericDollars = typeof dollars === 'string' ? parseFloat(dollars) : dollars;
  if (isNaN(numericDollars)) return 0;
  return Math.round(numericDollars * 100);
};

export const formatDecimalInput = (value: string, maxDecimals: number = 2): string => {
  // Remove any non-digit characters except decimal point
  let cleanedValue = value.replace(/[^\d.]/g, '');

  // Remove extra decimal points (only allow one)
  const decimalPoints = cleanedValue.split('.');
  if (decimalPoints.length > 2) {
    cleanedValue = decimalPoints[0] + '.' + decimalPoints.slice(1).join('');
  }

  // Limit decimal places
  if (cleanedValue.includes('.')) {
    const [integerPart, decimalPart] = cleanedValue.split('.');
    if (decimalPart.length > maxDecimals) {
      cleanedValue = integerPart + '.' + decimalPart.slice(0, maxDecimals);
    }
  }

  return cleanedValue;
};

export const getFieldError = (
  formik: { touched: any; errors: any },
  fieldName: string
): string => {
  const field = fieldName
    .split(".")
    .reduce((obj: any, key) => obj?.[key], formik.touched);
  const error = fieldName
    .split(".")
    .reduce((obj: any, key) => obj?.[key], formik.errors);
  return field && error ? error : "";
};

